import React from "react";
import ActionButtonUpdate from "../../../../common/button/action/ActionButtonUpdate";

interface Props {
  onClickUpdate: () => void;
  isDisplayUpdateButton?: boolean;
}

export default function TableActionButton(props: Props) {
  return (
    <div className="row justify-content-center">
      {props.isDisplayUpdateButton ? (
        <ActionButtonUpdate onClick={props.onClickUpdate} />
      ) : (
        ""
      )}
    </div>
  );
}
